<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='科秘书考评' label2="评分详细" url="/achievement/sectionsecretary/scorerecordlist"></PageHead>
      <div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <div style="width: 100%;overflow: auto;">
            <div class="form-group m-form__group row">
              <label class="col-xl-2 col-form-label">姓名：</label>
              <div class="col-xl-2" style="padding-top: 8px;">
                {{SecretaryName}}
              </div>
              <label class="col-xl-1 col-form-label">科室：</label>
              <div class="col-xl-2" style="padding-top: 8px;">
                {{SecName}}
              </div>
              <label class="col-xl-1 col-form-label">工号：</label>
              <div class="col-xl-2" style="padding-top: 8px;">
                {{SecretaryNo}}
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-xl-2 col-form-label">年度：</label>
              <div class="col-xl-2" style="padding-top: 8px;">
                {{ScoreYear}}
              </div>
              <label class="col-xl-1 col-form-label">季度：</label>
              <div class="col-xl-2" style="padding-top: 8px;">
                {{ScoreQuarter}}
              </div>
            </div>
            <div v-html="tabScore">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SectionSecretaryScoreRecord',
    data() {
      return {
        condition: {
          token: '',
          id: ''
        },
        tabScore: '',
        SecretaryName: '',
        SecName: '',
        SecretaryNo: '',
        ScoreYear: '',
        ScoreQuarter: ''
      }
    },
    methods: {
      LoadCPIDetail: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APISecretaryScore/CPIDetail', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.tabScore = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            this.tabScore = ''
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LoadSecretaryScoreInfo: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APISecretaryScore/ViewInfo', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.SecretaryName = res.data.Data.SecretaryName
              this.SecName = res.data.Data.SecName
              this.SecretaryNo = res.data.Data.SecretaryNo
              this.ScoreYear = res.data.Data.ScoreYear
              if (res.data.Data.ScoreQuarter == 1) {
                this.ScoreQuarter = '一季度'
              } else if (res.data.Data.ScoreQuarter == 2) {
                this.ScoreQuarter = '二季度'
              } else if (res.data.Data.ScoreQuarter == 3) {
                this.ScoreQuarter = '三季度'
              } else if (res.data.Data.ScoreQuarter == 4) {
                this.ScoreQuarter = '四季度'
              } else {
                this.ScoreQuarter = ''
              }
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.id = this.$route.params.id
      this.LoadSecretaryScoreInfo()
      this.LoadCPIDetail()
    }
  }
</script>

<style scoped="scoped">
  @import '../../../assets/css/stuscore.css'
</style>
